export default "__VITE_ASSET__Crk6Sbj6__"